import React from 'react';

import { SVGComponentProps } from './svg.types';

const ArrowTopSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 11"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3474 10.2795C14.8762 10.2835 14.4212 10.0999 14.074 9.76557L8.57143 4.30224L3.06887 9.76557C2.72272 10.1003 2.26924 10.2861 1.79853 10.2861C1.32782 10.2861 0.874338 10.1003 0.528191 9.76557C0.36173 9.60548 0.228814 9.41081 0.137885 9.19393C0.0469557 8.97704 0 8.74269 0 8.50574C0 8.2688 0.0469557 8.03444 0.137885 7.81756C0.228814 7.60067 0.36173 7.406 0.528191 7.24591L7.3017 0.52339C7.64645 0.187249 8.09961 0.000419617 8.5702 0.000419617C9.0408 0.000419617 9.49396 0.187249 9.83871 0.52339L16.6147 7.23949C16.7811 7.39958 16.914 7.59425 17.005 7.81113C17.0959 8.02801 17.1429 8.26237 17.1429 8.49932C17.1429 8.73626 17.0959 8.97062 17.005 9.1875C16.914 9.40438 16.7811 9.59905 16.6147 9.75915C16.2697 10.093 15.8167 10.2768 15.3474 10.2731"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ArrowTopSVG;
